export default __webpack_public_path__ + "img/flame.c3f2c90b.svg";